import Routing from 'fos-routing';
// import file with routes data
import RoutingData from '../router/fos_js_routes_export';

// set data
Routing.setData(RoutingData);

// export library
export default Routing;


// WEBPACK FOOTER //
// ./src/core/router/router.js